import {
  SilenceData,
  SilenceFormData,
} from '@/react/portainer/observability/AlertsView/ActiveAlertsDatatable/silenceTypes';

import { StatusBadgeType } from '@@/StatusBadge';

import { ActiveAlertsResponse, ActiveAlertRow, AlertState } from './types';

const GO_ZERO_TIME = '0001-01-01T00:00:00.000Z';

export function transformToActiveAlertRows(
  response: ActiveAlertsResponse
): ActiveAlertRow[] {
  return response.flatMap((alertGroup) =>
    alertGroup.Payload.map((alert) => {
      const summary =
        alert.labels.summary ??
        alert.annotations?.summary ??
        alert.labels.alertname;
      const updatedAt =
        alert.updatedAt === GO_ZERO_TIME ? alert.startsAt : alert.updatedAt;

      return {
        id: alert.fingerprint,
        fingerprint: alert.fingerprint,
        alertName: alert.labels.alertname,
        summary,
        message:
          alert.labels.message ??
          alert.annotations?.message ??
          alert.annotations?.description ??
          summary,
        severity: alert.labels.severity,
        state: alert.status.state,
        source: alert.labels.source ?? alert.labels.alert_source ?? '',
        instance: alert.labels.instance ?? '',
        category: alert.labels.category ?? '',
        environmentName: alert.labels.portainer_environment_name ?? '',
        environmentGroupName:
          alert.labels.portainer_environment_group_name || 'Unassigned',
        startsAt: new Date(alert.startsAt),
        endsAt: new Date(alert.endsAt),
        updatedAt: new Date(updatedAt),
        receivers: alert.receivers.map((r) => r.name),
        labels: Object.fromEntries(
          Object.entries(alert.labels).filter(
            ([, value]) => value !== undefined
          )
        ) as Record<string, string>,
        alertRuleId: alert.labels.alert_rule_id,
      };
    })
  );
}

export function silenceAlertFormDataToPayload(
  formData: SilenceFormData
): SilenceData[] {
  return (
    formData.matchers
      .map((matchers) => ({
        ...formData,
        matchers,
      }))
      // transform 'Unassigned' environment groups to empty strings
      .map((silence: SilenceData) => ({
        ...silence,
        matchers: silence.matchers.map((match) => ({
          ...match,
          value:
            match.value === 'Unassigned' && match.name === 'environment_group'
              ? ''
              : match.value,
        })),
      }))
  );
}

export const statusToBadgeType: Record<AlertState, StatusBadgeType> = {
  active: 'danger',
  firing: 'danger',
  inactive: 'success',
  pending: 'warning',
};
